<div class="mapfre-fs-l mapfre-mt-l mapfre-mb-sm dark">{{inputType === 'additional-services' ? 'Servicios' : 'Especialidades'}}</div>
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="tree main-branch">
  <!-- This is the tree node template for leaf nodes -->
  <!-- There is inline padding applied to this node using styles.
      This padding value depends on the mat-icon-button width. -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
    <div [innerHTML]="node.name">
    </div>
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild ">
    <div class="mat-tree-node">
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
        </mat-icon>
      </button>
      <span [innerHTML]="node.name"></span>
    </div>
    <!-- There is inline padding applied to this div using styles.
            This padding value depends on the mat-icon-button width.  -->
    <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
      <div class="mapfre-mt-sm gray1 flex mapfre-mb-s" *ngIf="node.observations && state.tabIndex === 0">
        <div class="mapfre-ml-xs">{{ node.observations }}</div>
      </div>
    </div>
    <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>